import { Link,Outlet,Route,Routes, useNavigate } from "react-router-dom";
import Summary from "./Pages/Summary"
import Compensation from "./Pages/Compensation"
import summary from "./Pages/Summary"
import Personal from "./Pages/Personal";
import Performance from "./Pages/Performance";
import TimeOffs from "./Pages/TimeOff";
import Support from "./Pages/Support";
import Settings from "./Settings/Settings";
import AddUser from "./AddUser/AddUser";
import EditUser from "./EditUser/EditUser";
import Transact from "./Transact/Transact";
import Reports from "./PayReports/Reports";
import PTOReports from "./Pages/PTOReports";
import PTORequest  from "./Timeoff/Timeoff"
import AdvanceReports from "./Pages/AdvanceReports";
import DeleteUser from "./DeleteUser/DeleteUser";
import img1 from "../Images/BLACK.png"

import "./SideBar.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AuthContext from "../Context/AuthProvider";
import { faPlus,faSignOutAlt,faCogs,faSuitcaseRolling,faTools,faUser,faUsers,faChevronDown, faTimes } from '@fortawesome/free-solid-svg-icons'
import { useContext, useState } from "react";
import useLogout from "../Hooks/useLogout";


function SideBar(){  

    const { setAuth,auth } = useContext(AuthContext);
    const [visible, setVisible] = useState(false)
    const navigate = useNavigate()
    const logout = useLogout()

    const SignOut = async () => {
        await logout();
        navigate('/')

        console.log("logged out")
    }


  const setSignViz = () =>{
    setVisible(!visible)

}



    return <> 

        
     <div className="SideCard">  

            <div className="TopBanner">
                        {/* <div className="Logo"><h2>NERDAY</h2></div> */}
                        <Link to={"/Dashboard"}>
                            <div className="Logo">
                                
                            
                                <img src={img1}></img>
                            
                            </div>
                        </Link>

                        <div className="Dropdown" >
                
                            <button onClick={setSignViz}>

                                    <h2>{ String(auth?.user).substring(0,1).toUpperCase()}</h2>
                                        
                            </button>

                            { visible  &&

                                        <div className="overlayDropdown" >

                                            <div className="DOverlayCover"> 
                                                  <div className="emailSection"> 

                                                        <div className="email"> <p>{String(auth?.user)}</p> </div>
                                                        <div className="cross"><p><FontAwesomeIcon onClick={()=>{setSignViz(false)}} icon={faTimes} className="FontAwesomeIcon"/> </p> </div>
                                                        {/* <div className="icon">X</div> */}

                                                  </div>
                                                  <div className="iconSection"> 
                                                      <button onClick={setSignViz}>

                                                               <h2>{ String(auth?.user).substring(0,1).toUpperCase()}</h2>
                                                        
                                                     </button>

                                                  </div>
                                                  <div className="nameSection"> 
                                                              <p>{`Hi, `+ String(auth?.foundUser?.name)+`!`}</p>

                                                  </div>
                                                  <div className="actionsSection"> 

                                                        <div className="child"><p><FontAwesomeIcon icon={faPlus} className="FontAwesomeIcon"/> {"Add Account"+`    |    `} </p> </div>
                                                        <div className="child" onClick={SignOut}><p><FontAwesomeIcon icon={faSignOutAlt} className="FontAwesomeIcon"/> {``+"Sign Out"}</p>  </div>

                                                  </div>
                                                  <div className="policiesSection"> 

                                                            <p>Privacy policy . Terms of service</p>

                                                  </div>


                                            </div>

                                            {/* <button onClick={SignOut}>SIGN OUT HERE</button> */}

                                        </div>
                            }
                                  
                        </div>

         </div>
        
   
         
     {/* <h2>NERDAY</h2> */}
   
   
          <div className="ContRoute">  

                <div className="Controls">  
                {/* <div className="userCredentials">

                            
                           
                </div> */}
                        <ul>


                             <li><Link to="" className="textLink">
                           
                                <FontAwesomeIcon icon={faUsers} className="FontAwesomeIcon" />
                                Team</Link></li>

                            <li><Link to="Summary" className="textLink">
                            
                                <FontAwesomeIcon icon={faUser} className="FontAwesomeIcon"/>
                                User</Link></li>
                           
                           
                            
                            <li><Link to="TimeOffs" className="textLink">
                               
                                <FontAwesomeIcon icon={faSuitcaseRolling} className="FontAwesomeIcon"/>
                                Time Off</Link></li>
                            <li><Link to="Support" className="textLink">
                              
                                <FontAwesomeIcon icon={faCogs} className="FontAwesomeIcon"/>
                                Operations</Link></li>
                            {/* <li><Link to="/pr" className="textLink">
                              
                                <FontAwesomeIcon icon={faCogs} className="FontAwesomeIcon"/>
                                Payroll</Link></li> */}
                            
                        </ul>
   
                        
                </div> 

                <div className="Outlets">
                   
                    <Routes>    
                    {/* <Route path="about" element={<About />}/> */}
                                
                              
                    <Route path="Timeoffs" element={<TimeOffs />}/>
                                  
                    {/* <Route path="PTOReports" element={<PTOReports />}/> */}

                        <Route index element={<Compensation/>}/>  
                        <Route path="Summary" element={<Summary/>}/>  
                        <Route path="Personal" element={<Personal/>}/>  
                        <Route path="Performance" element={<Performance/>}/>  
                        
                        {/* <Route path="Compensation" element={<Compensation/>}/>   */}
                        {/* <Route path="TimeOff" element={<TimeOff/>}/>   */}
                        <Route path="Support" element={<Settings/>}/>  
                        <Route path="AddUser" element={<AddUser/>}/>  
                        <Route path="EditUser" element={<EditUser/>}/>  
                        <Route path="Reports" element={<Reports/>}/>  
                        <Route path="Transact" element={<Transact/>}/>  
                        <Route path="AdvanceReports" element={<AdvanceReports/>}/>  
                        <Route path="PTORequest" element={<PTOReports/>}/>  
                        <Route path="PTOReports" element={<PTORequest/>}/>  
                        <Route path="DeleteUser" element={<DeleteUser/>}/>  

                    </Routes>

                  {/* <Outlet/> */}
              </div>

        </div>
      
          
         
         
         
         

     </div>
        
    
    </>

}

export default SideBar;